import styled from "styled-components";
import { TEXT_GAP, TOOLTIP_POSITIONING } from "./constants";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";

const ARROW_HIGHT = "10px";

export const CutleryOptInOut = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    borderRadius: getCornerRadius(theme, "xSmall"),
    border: `1px solid ${theme.colors[theme.colorMode].divider}`,
    padding: `${theme.spacing.xSmall} ${theme.spacing.small} ${theme.spacing.xSmall} ${theme.spacing.xSmall}`,
    "> span": {
        paddingLeft: TEXT_GAP,
    },
}));

export const CutleryLabel = styled.label(() => ({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    paddingLeft: TEXT_GAP,
}));

export const FTUENudge = styled.div(({ theme }) => ({
    position: "absolute",
    right: 0,
    top: `${TOOLTIP_POSITIONING.TOP}px`,
    borderRadius: theme.cornerRadius.medium,
    padding: theme.spacing.small,
    background: theme.colors[theme.colorMode].background_inverse_Primary,
    marginTop: theme.spacing.medium,
    boxShadow: `0px 12px 28px 0px rgba(27, 30, 36, 0.10)`,
    display: "flex",
    alignItems: "center",
    zIndex: 2,

    "div>svg": {
        marginLeft: theme.spacing.xSmall,
    },

    "::before": {
        content: '""',
        position: "absolute",
        top: `calc(${ARROW_HIGHT} * -1)`,
        right: theme.spacing.small,
        transform: "translateX(-50%)",
        borderLeft: `${ARROW_HIGHT} solid transparent`,
        borderRight: `${ARROW_HIGHT} solid transparent`,
        borderBottom: `${ARROW_HIGHT} solid ${theme.colors[theme.colorMode].background_inverse_Primary}`,
        boxShadow: `0px 12px 28px 0px rgba(27, 30, 36, 0.10)`,
    },
}));
